module.exports = __webpack_public_path__ + "images/blog/blog_card/questions/5_881986928cd94d7751e61bdb2604f367.jpg";